import React from "react";
import "../../../../css/Turismo/turismo.css";

const imagenes = [
  require("../../../img/colectividades2026/colectividades-1.jpg"),
  require("../../../img/colectividades2026/colectividades-2.jpg"),
  require("../../../img/colectividades2026/colectividades-3.jpg"),
  require("../../../img/colectividades2026/colectividades-4.jpg"),
  require("../../../img/colectividades2026/colectividades-5.jpg"),
  require("../../../img/colectividades2026/colectividades-6.jpg"),
  require("../../../img/colectividades2026/colectividades-7.jpg"),
  require("../../../img/colectividades2026/colectividades-8.jpg"),
  require("../../../img/colectividades2026/colectividades-9.jpg"),
];

const FiestaAnualDeColectividades = () => (
  <div>
    <div
      className="colectividades text-center"
      style={{
        backgroundImage: `url(${require("../../../img/colectividades-2.jpeg")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundPositionY: "0px",
        paddingTop: 100,
        paddingBottom: 100,
        backgroundAttachment: "fixed",
        position: "relative",
        height: 450,
        marginBottom: 30,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
        }}
      />
    </div>
    <div className="container">
      <div className="info-colectividades">
        <h1 className="text-center">
          <strong>FIESTA ANUAL DE COLECTIVIDADES</strong>
        </h1>
        <p>
          El encuentro de Colectividades es uno de los festivales más convocados
          y tradiciones de la ciudad y la región, albergando de 3.000 a 5.000
          espectadores. Se trata de una festividad familiar, para disfrutar de
          una buena grilla artística, comidas típicas y paseo de artesanos.
        </p>
        <br />
        <div className="row">
          <section className="col-12">
            <div
              id="carouselColectividades"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                {imagenes.map((img, idx) => (
                  <div
                    className={`carousel-item${idx === 0 ? " active" : ""}`}
                    key={idx}
                  >
                    <img
                      src={img}
                      alt={`colectividades-${idx + 1}`}
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselColectividades"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Anterior</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselColectividades"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Siguiente</span>
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
);

export default FiestaAnualDeColectividades;
